module.exports = __webpack_public_path__ + "img/16.29310eba.png";